/* Jančařík header – mobilní menu, panel vyhledávání, naposledy prohlížené */
(function () {
  function init(root) {
    if (!root || root.dataset.jcInit) return;
    root.dataset.jcInit = '1';

    var html = document.documentElement;
    var mqMobile = window.matchMedia('(max-width: 989px)');

    /* ---------- Mobilní menu ---------- */
    var drawer = root.querySelector('[data-jc-drawer]');
    var openBtn = root.querySelector('[data-jc-drawer-open]');

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      html.style.overflow = 'hidden';
      var c = drawer.querySelector('[data-jc-drawer-close-btn]');
      if (c) c.focus();
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
      html.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.querySelectorAll('[data-jc-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      drawer.querySelectorAll('[data-jc-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-jc-tab');
          drawer.querySelectorAll('[data-jc-tab]').forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
          drawer.querySelectorAll('[data-jc-tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-jc-tabpanel') !== id; });
        });
      });
      drawer.querySelectorAll('[data-jc-acc-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var acc = btn.closest('.jc-acc');
          var open = !acc.classList.contains('is-open');
          acc.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', String(open));
          var panel = acc.querySelector('.jc-acc__panel');
          if (panel) panel.hidden = !open;
        });
      });
    }
    mqMobile.addEventListener && mqMobile.addEventListener('change', function (e) { if (!e.matches) closeDrawer(); });

    /* ---------- Odpočet v pruhu s akcí ---------- */
    var cd = root.querySelector('[data-jc-countdown]');
    if (cd) {
      var cdEnd = parseInt(cd.getAttribute('data-end'), 10) * 1000;
      var cdOut = cd.querySelector('[data-jc-countdown-time]');
      var cdIv = null;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var cdTick = function () {
        var ms = cdEnd - Date.now();
        if (ms <= 0) {
          if (cdIv) clearInterval(cdIv);
          if (cd.hasAttribute('data-hide-bar')) {
            var ann = root.querySelector('.jc-ann');
            if (ann) ann.hidden = true;
            var sec = root.closest('.shopify-section');
            if (sec) sec.style.top = '0';
          } else {
            cd.hidden = true;
          }
          return;
        }
        var t = Math.floor(ms / 1000);
        var h = Math.floor(t / 3600); t %= 3600;
        var m = Math.floor(t / 60); var sec2 = t % 60;
        cdOut.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec2);
      };
      cdTick();
      cdIv = setInterval(cdTick, 1000);
    }

    /* ---------- Naposledy prohlížené ---------- */
    var KEY = 'jc_recent_v1';
    function readRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function writeRecent(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    var currentHandle = null;
    var cur = document.querySelector('script[data-jc-current-product]');
    if (cur) {
      try {
        var p = JSON.parse(cur.textContent);
        currentHandle = p.handle;
        var list = readRecent().filter(function (x) { return x && x.handle !== p.handle; });
        list.unshift(p);
        writeRecent(list.slice(0, 8));
      } catch (e) {}
    }

    /* ---------- Vyhledávání ---------- */
    var search = root.querySelector('[data-jc-search]');
    if (!search) return;
    var input = search.querySelector('[data-jc-search-input]');
    var panel = search.querySelector('[data-jc-search-panel]');
    var def = search.querySelector('[data-jc-search-default]');
    var res = search.querySelector('[data-jc-search-results]');
    var header = root.querySelector('[data-jc-header]');
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}} Kč';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function money(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      function fmt(num, dec, thou, decSep) {
        var parts = num.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return parts.join(decSep);
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount': return fmt(n, 2, ',', '.');
          case 'amount_no_decimals': return fmt(n, 0, ',', '.');
          case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
          case 'amount_with_space_separator': return fmt(n, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return fmt(n, 0, ' ', ',');
          default: return fmt(n, 2, ',', '.');
        }
      });
    }
    function sized(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    function item(p) {
      return '<a class="jc-prod" href="' + esc(p.url) + '">' +
        (p.image ? '<img class="jc-prod__img" src="' + esc(p.image) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="jc-prod__img"></span>') +
        '<span class="jc-prod__body"><span class="jc-prod__title">' + esc(p.title) + '</span>' +
        (p.sub ? '<span class="jc-prod__sub">' + esc(p.sub) + '</span>' : '') + '</span>' +
        (p.price ? '<span class="jc-prod__price">' + esc(p.price) + '</span>' : '') +
        '</a>';
    }
    function renderRecent() {
      var box = search.querySelector('[data-jc-recent]');
      if (!box) return;
      var list = readRecent().filter(function (x) { return x && x.handle !== currentHandle; }).slice(0, 3);
      box.hidden = list.length === 0;
      box.querySelector('[data-jc-recent-list]').innerHTML = list.map(item).join('');
    }
    var clearBtn = search.querySelector('[data-jc-recent-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () { writeRecent([]); renderRecent(); input.focus(); });

    function openSearch() {
      if (search.classList.contains('is-open')) return;
      renderRecent();
      if (mqMobile.matches && header) {
        panel.style.setProperty('--jc-panel-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
      }
      panel.hidden = false;
      search.classList.add('is-open');
    }
    function closeSearch() {
      panel.hidden = true;
      search.classList.remove('is-open');
      if (mqMobile.matches && !input.value.trim()) {
        root.classList.remove('is-search-open');
        var tg = root.querySelector('[data-jc-search-toggle]');
        if (tg) tg.setAttribute('aria-expanded', 'false');
      }
    }
    input.addEventListener('focus', openSearch);
    input.addEventListener('click', openSearch);
    var toggle = root.querySelector('[data-jc-search-toggle]');
    if (toggle) toggle.addEventListener('click', function () {
      var open = !root.classList.contains('is-search-open');
      root.classList.toggle('is-search-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) { input.focus(); openSearch(); } else { closeSearch(); }
    });
    document.addEventListener('click', function (e) {
      if (search.contains(e.target) || (toggle && toggle.contains(e.target))) return;
      closeSearch();
    });
    window.addEventListener('scroll', function () { if (mqMobile.matches && search.classList.contains('is-open') && header) {
      panel.style.setProperty('--jc-panel-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
    } }, { passive: true });

    var timer = null;
    var ctrl = null;
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var searchUrl = search.querySelector('form').getAttribute('action') || '/search';

    function runSearch(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          var all = '<a class="jc-sp__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&amp;options%5Bprefix%5D=last">Zobrazit všechny výsledky →</a>';
          if (!ps.length) {
            res.innerHTML = '<p class="jc-sp__empty">Pro „' + esc(q) + '“ jsme nic nenašli.</p>';
          } else {
            res.innerHTML = '<div class="jc-sp__group"><p class="jc-sp__title">Produkty</p><div>' +
              ps.map(function (p) {
                var img = p.image || (p.featured_image && p.featured_image.url) || '';
                return item({ url: p.url, title: p.title, image: sized(img), sub: p.type || p.product_type || '', price: p.price ? money(p.price) : '' });
              }).join('') + '</div></div>' + all;
          }
          def.hidden = true;
          res.hidden = false;
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      openSearch();
      if (q.length < 2) { res.hidden = true; def.hidden = false; return; }
      timer = setTimeout(function () { runSearch(q); }, 220);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeSearch(); }
    });
  }

  function boot() { document.querySelectorAll('[data-jc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
